import { Typography } from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { SplashScreen } from 'shared/layout/SplashScreen';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';
import { SuperPayRequestShipperWebViewBanner } from 'shared/modules/superpay/SuperPayRequestShipperBanner';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { useSuperPaySettings } from '../../../profile/data/SuperPayAPI';
import { BankDetails } from '../../../profile/superpay/account-details/BankDetails';
import { useTrackAccountDetailsOpened } from '../../../profile/superpay/account-details/useTrackAccountDetailsOpened';
import { isRedirectFromLoadboard } from '../../CarrierWebviewHeader';
import { SuperPayWebviewHeader } from './SuperPayWebviewHeader';
import { useInterceptBackButton } from './useInterceptBackButton';

interface AccountDetailsWebViewPageProps {
  path: string;
}

export function AccountDetailsWebViewPage({
  path,
}: AccountDetailsWebViewPageProps) {
  const { data: superPaySettings, isInitialLoading } = useSuperPaySettings();
  const bankAccount = superPaySettings?.bank_accounts?.[0];
  const verificationStatus = bankAccount?.verification_status;

  const { data: settings } = useCarrierSettings();
  const hasAccountingFeature = settings?.user.has_accounting_feature;

  const isRedirect = isRedirectFromLoadboard();

  useTrackAccountDetailsOpened(verificationStatus);

  useDocumentTitle('SuperPay');
  useInterceptBackButton();

  if (isInitialLoading) {
    return <SplashScreen />;
  }

  return (
    <SuperPayWebviewHeader>
      <PermissionView name="superpay" permission="can_edit">
        <Box
          marginLeft="auto"
          marginRight="auto"
          padding="medium"
          paddingLeft="small"
          paddingRight="small"
          maxWidth="496px"
        >
          <Stack space="large">
            {!isRedirect && <Typography variant="h2">SuperPay</Typography>}

            <BankDetails
              path={path}
              hasAccountFeature={hasAccountingFeature}
              bankAccount={superPaySettings?.bank_accounts?.[0]}
              previousBankAccount={superPaySettings?.bank_accounts?.[1]}
              hoursUntilUpdateAllowed={
                superPaySettings?.hours_until_update_allowed
              }
            />

            {settings?.superpay.is_invite_available && (
              <SuperPayRequestShipperWebViewBanner />
            )}
          </Stack>
        </Box>
      </PermissionView>
    </SuperPayWebviewHeader>
  );
}
